import BaseService from '@/api/checkInBase';
import { ReducerState, MainState, storeName } from '@/redux/reducers/bill/invoice';
import { createActionMiddleware } from '@/redux/actions/reservation/helper';
import { uuid } from '@/utils';
import { parseFen2Yuan } from '@/utils/number';
import { InvoiceAction } from './constant';

// getState函数覆写
const actionWrapper = createActionMiddleware<ReducerState>(storeName);

// 更新初始化状态
const setInitStatus = (isInit: boolean) => {
  return { type: InvoiceAction.setInitStatus, payload: isInit };
};

// 更新loading状态
export const setLoadingStatus: (isLoading: boolean) => void = (isLoading) => {
  return {
    type: InvoiceAction.setLoadingStatus,
    payload: isLoading,
  };
};

/* 发票填写信息相关操作 */
// 添加&移除一行数据
export const alterInvoiceItemData: (type: 'add' | 'remove', id?: string) => void = (type, id) => {
  return actionWrapper((dispatch, getState) => {
    const { invoices } = getState();
    let newInvoices = [];
    if (type === 'remove') {
      newInvoices = invoices.filter((item) => item.id !== id);
      dispatch({
        type: InvoiceAction.setInvoiceItems,
        payload: <MainState>{
          invoices: newInvoices,
        },
      });
      return;
    }
    if (type === 'add' && invoices.length < 20) {
      newInvoices = [
        ...invoices,
        { id: uuid(), amount: null, invoiceCode: '', invoiceNo: '', invoiceType: null },
      ];
      dispatch({
        type: InvoiceAction.setInvoiceItems,
        payload: <MainState>{
          invoices: newInvoices,
        },
      });
    }
  });
};
// 属性编辑
export const inputInvoiceInfos: (
  type: 'amount' | 'invoiceCode' | 'invoiceNo' | 'invoiceType',
  id: string,
  value: any,
) => void = (type, id, value) => {
  return actionWrapper((dispatch, getState) => {
    const { invoices } = getState();
    let newInvoices = [];
    newInvoices = invoices.map((item) => {
      return {
        ...item,
        [type]: item.id === id ? value : item[type],
      };
    });

    dispatch({
      type: InvoiceAction.setInvoiceItems,
      payload: <MainState>{
        invoices: newInvoices,
      },
    });
  });
};

// 更新备注
export const updateRemark: (value: string) => void = (value) => {
  return {
    type: InvoiceAction.updateRemark,
    payload: {
      remark: value,
    },
  };
};

// 修改本次开票金额
export const updateInvoiceAmount: (value: any, orderNo: any) => void = (value, orderNo) => {
  return actionWrapper((dispatch, getState) => {
    const { orderList } = getState();
    let newOrderList = [];
    newOrderList = orderList.map((item) => {
      if (item.orderNo === orderNo)
        return {
          ...item,
          invoiceAmount: value,
        };
      return item;
    });

    dispatch({
      type: InvoiceAction.updateInvoiceAmount,
      payload: <MainState>{
        orderList: newOrderList,
      },
    });
  });
};

// 初始化state
export const resetState = () => {
  return (dispatch) => {
    // 未初始化状态
    dispatch({
      type: InvoiceAction.initDefaultState,
      payload: <MainState>{
        isInit: false,
        isLoading: false,
        orderList: [],
        categories: [],
        invoices: [
          {
            id: uuid(),
            amount: null,
            invoiceCode: '',
            invoiceNo: '',
            invoiceType: null,
          },
        ],
        remark: '',
      },
    });
  };
};

// 页面初始化
export const initPageState: (initFunc: () => Promise<MainState>) => void = (initFunc) => {
  return async (dispatch) => {
    try {
      // 未初始化状态
      dispatch({
        type: InvoiceAction.initDefaultState,
        payload: <MainState>{
          isInit: false,
          isLoading: true,
          orderList: [],
          categories: [],
          invoices: [
            {
              id: uuid(),
              amount: null,
              invoiceCode: '',
              invoiceNo: '',
              invoiceType: null,
            },
          ],
          remark: '',
        },
      });
      // 调用初始化方法
      const initState = await initFunc();
      // 设置初始化数据
      dispatch({ type: InvoiceAction.initDefaultState, payload: initState });
      dispatch(setInitStatus(true));
      dispatch(setLoadingStatus(false));
    } catch (_) {
      dispatch(setInitStatus(false));
    }
  };
};

// 更新开票订单列表信息
export const updateOrderList: (updateValue: any[]) => void = (updateValue) => {
  return actionWrapper((dispatch) => {
    dispatch({
      type: InvoiceAction.setOrders,
      payload: updateValue,
    });
  });
};

// 添加订单
export const addOrderList: (list: any) => void = (list: any) => {
  return actionWrapper((dispatch, getState) => {
    const { orderList = [] } = getState();
    const newOrderList = [...orderList];
    list.forEach((item) => {
      const index = newOrderList.findIndex((order) => order.orderNo === item.orderNo);
      if (index === -1) {
        newOrderList.push({
          ...item,
          invoiceAmount: parseFen2Yuan(item.availableAmt - item.invoicedAmt),
        });
      }
    });

    dispatch({
      type: InvoiceAction.updateInvoiceAmount,
      payload: <MainState>{
        orderList: newOrderList,
      },
    });
  });
};

// 获取全部状态
export const getMainState: (callback: (state: ReducerState) => void) => void = (callback) => {
  return actionWrapper((_, getState) => {
    try {
      callback(getState());
    } catch (e) {
      //
    }
  });
};
